import { ApiQuery } from "./../../../domain/clients/ApiQuery";
import { CreateUserRequest } from "@/data/dtos/requests";
import {
  CreatePsiInput,
  CreatePsiResult,
  UpdateUserInput,
} from "@/domain/dtos/inputs";
import { NotFoundError } from "@/domain/errors";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { UserHomeInfoResponse, UserResponse } from "../../dtos/responses";
import { UserDataSource } from "./UserDataSource";

export class UserRemoteDataSource implements UserDataSource {
  constructor(private readonly api: ApiService) {}

  async getUserHomeInfo(): Promise<UserHomeInfoResponse> {
    const data = await this.api.get(Endpoints.home_info);

    if (!data) {
      throw new NotFoundError("Informações do usuário");
    }
    // Backend tá devolvendo a resposta direto no body e não do data, por isso to fazendo essa gambis
    return data as UserHomeInfoResponse;
  }
  async getUserById(id: number): Promise<UserResponse> {
    const { data } = await this.api.get<UserResponse>(
      `${Endpoints.user}/${id}`,
    );

    if (!data) {
      throw new NotFoundError("Usuário");
    }

    return data;
  }

  async getUserBySlug(slug: string): Promise<UserResponse> {
    const { data } = await this.api.get<UserResponse>(
      `${Endpoints.users_slug}/${slug}`,
    );

    if (!data) {
      throw new NotFoundError("Usuário");
    }

    return data;
  }
  async updateUser(
    id: number,
    params: Partial<UpdateUserInput>,
  ): Promise<UserResponse> {
    // TODO: ValidationUtils.validate(UserSchema, params)
    const { data } = await this.api.post<UserResponse, any>(
      `${Endpoints.user}/${id}/edit`,
      params,
      { encodeType: "formData" },
    );

    if (!data) {
      throw new NotFoundError("Usuário");
    }

    return data;
  }

  async createUser(params: CreateUserRequest): Promise<UserResponse> {
    // TODO: ValidationUtils.validate(UserSchema, params)
    const { data } = await this.api.post<UserResponse, CreateUserRequest>(
      Endpoints.user,
      params,
      { encodeType: "formData" },
    );

    if (!data) {
      throw new Error("Erro ao fazer cadastro");
    }

    return data;
  }

  deleteUser(id: number): Promise<any> {
    return this.api.delete(`${Endpoints.user}/${id}`);
  }

  checkIfEmailAlreadyExists(params: { email: string }): Promise<any> {
    return this.api.post(Endpoints.user_registered_email, params);
  }

  async findPsis(params: {
    search?: string;
    page?: number;
    seed?: number;
  }): Promise<{
    psis: UserResponse[];
    total: number;
  }> {
    const { data, total } = await this.api.get<UserResponse[]>(
      Endpoints.find_psychologists,
      params,
    );

    if (!data) {
      return {
        psis: [],
        total: 0,
      };
    }

    return {
      psis: data,
      total: total ?? 0,
    };
  }
}
